<template>
    <input type="file" @change="onFileSelect" :multiple="true" />
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options, Vue } from 'vue-class-component';


@Options({})
export default class fileInputMultiple extends mixins(WithModel) {

    onFileSelect(ev){
        let files = ev.target.files as FileList;
        let toEmit = [];
        for(let i = 0; i < files.length; i++){
            toEmit.push(files[i]);
        }
        this.emitModel(toEmit);
    }
}

</script>